// extracted by mini-css-extract-plugin
export default {"logo":"u5Ch","neonPulse":"pXrg"};